import { JsonObject, JsonProperty, Optional } from 'json-ts-mapper';

@JsonObject
export class Region {
  constructor (
    codeRegion?: string,
    libelle?: string,
    typeRegion?: string,
    corrCom?:string,
    numTelCc?:string,
    eMailCc?:string
  ) {
    this.codeRegion = codeRegion as any;
    this.libelle = libelle as any;
    this.typeRegion = typeRegion as any;
    this.numTelCc = numTelCc as any;
    this.corrCom = corrCom as any;
    this.eMailCc = eMailCc as any;
  }

    @JsonProperty(String)
    codeRegion?:string;

    @JsonProperty(String)
    libelle?:string;

    @JsonProperty(String)
    typeRegion?:string;

    @JsonProperty(String)
    @Optional
    corrCom?:string;

    @JsonProperty(String)
    @Optional
    numTelCc?:string;

    @JsonProperty(String)
    @Optional
    eMailCc?:string;
}
